import { Group, Title } from '@mantine/core';
import { AddButton } from '../buttons/AddButton';

export const IndexPageHeader = () => {
    return (
        <Group justify="space-between" p="md">
            <Title order={2}>Payment Methods</Title>
            <AddButton />
        </Group>
    );
};
